import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import { fciFetch } from "@/shared/lib/fci";
import type { UserPreferences } from "./types";

export const getUserPreferences = () =>
    fciFetch<UserPreferences>("/api/search-preferences", {
        fci: {
            // Fetches saved user preferences (exactness, filters, etc.)
            // If it fails, the form falls back to defaults
            errorType: FCI_ERROR.Convenience,
            errorInfo: "getUserPreferences",
        },
    });
